import darkTheme from "./dark"
import lightTheme from "./light"

const themes = {
    light: lightTheme,
    dark: darkTheme,
}

export default themes
